type MergeLinkCardFooterProps = {
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const MergeLinkCardFooter = ({ onClick, children }: MergeLinkCardFooterProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-[13px] leading-4 font-semibold h-[60px] w-[375px] rounded-b-[12px] overflow-hidden px-5 pt-8 pb-3 absolute bottom-0 left-0 right-0 z-[99] cursor-pointer border-0 transition-colors duration-150 ease-out"
    >
      {children}
    </button>
  );
};

export default MergeLinkCardFooter;
